import { QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME } from 'QuickflowsApp/ts/constants';
import { UrlsService } from 'Angular/services/core/urls.service';
import { CookieService } from 'ngx-cookie-service';
import { MultiSelectQuickflowsComponent } from './multi-select-quickflows.component';
import { SingleSelectQuickflowsComponent } from './single-select-quickflows.component';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service";
import * as i2 from "Angular/services/core/urls.service";
import * as i3 from "@angular/common";
import * as i4 from "QuickflowsApp/ts/features/quickflows-menu/components/multi-select-quickflows.component";
import * as i5 from "./single-select-quickflows.component";
const _c0 = a0 => ({ active: a0 });
/**
 *
 * Quickflows Menu Component
 *
 * Controls the single select and multi select quickflow tabs.
 *
 * Input Properties:
 *   displaySecurityId: The display security ID to initialize this component with, e.g. VTSAX
 *   securityId: The security ID to initialize this component with, e.g. M:VTSAX
 *   securityName: The security name to initialize this component with, e.g. Vanguard Financials Index Admiral
 *   securityUrl: The security url to navigate e.g.  /mutual_funds/M:VFAIX
 *
 */
export class QuickflowsMenuComponent {
    constructor(cookieService, urlsService) {
        this.cookieService = cookieService;
        this.urlsService = urlsService;
        this.isMenuOpened = false;
        this.showSingleSecurityQuickflowsTab = true;
        this.userPreferencesUrl = '';
    }
    ngOnInit() {
        this.setQuickflowMenuTab();
        this.userPreferencesUrl = this.urlsService.ACCOUNTS.PROFILE_COMMUNICATIONS;
    }
    setQuickflowMenuTab() {
        const onSingleSecurityTabCookie = this.cookieService.get(QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME);
        if (onSingleSecurityTabCookie) {
            this.showSingleSecurityQuickflowsTab = JSON.parse(onSingleSecurityTabCookie);
        }
    }
    setQuickflowMenuTabCookie() {
        this.cookieService.set(QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME, this.showSingleSecurityQuickflowsTab.toString(), { path: '/' });
    }
    focusOnSecurityInput() {
        setTimeout(() => {
            if (this.showSingleSecurityQuickflowsTab && this.singleSelectTab) {
                this.singleSelectTab.focusAutocompleter();
            }
            else if (!this.showSingleSecurityQuickflowsTab && this.multiSelectTab) {
                this.multiSelectTab.focusAutocompleter();
            }
        });
    }
    toggleQuickflowTab() {
        this.showSingleSecurityQuickflowsTab = !this.showSingleSecurityQuickflowsTab;
        this.setQuickflowMenuTabCookie();
        this.focusOnSecurityInput();
    }
}
QuickflowsMenuComponent.ɵfac = function QuickflowsMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QuickflowsMenuComponent)(i0.ɵɵdirectiveInject(i1.CookieService), i0.ɵɵdirectiveInject(i2.UrlsService)); };
QuickflowsMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuickflowsMenuComponent, selectors: [["ycn-quickflows-menu"]], viewQuery: function QuickflowsMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MultiSelectQuickflowsComponent, 5);
        i0.ɵɵviewQuery(SingleSelectQuickflowsComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiSelectTab = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singleSelectTab = _t.first);
    } }, inputs: { displaySecurityId: "displaySecurityId", securityId: "securityId", securityName: "securityName", securityUrl: "securityUrl" }, standalone: false, decls: 10, vars: 16, consts: [[1, "tabs"], [1, "nav", "nav-tabs", "nav-width-equal"], [1, "nav-item"], ["href", "javascript:void(0)", "data-test-id", "quickflows-single-tab", 1, "nav-link", 3, "click", "ngClass"], ["href", "javascript:void(0)", "data-test-id", "quickflows-comparison-tab", 1, "nav-link", 3, "click", "ngClass"], [1, "tab-content", 3, "hidden", "displaySecurityId", "securityId", "securityName", "securityUrl"]], template: function QuickflowsMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1)(2, "li", 2)(3, "a", 3);
        i0.ɵɵlistener("click", function QuickflowsMenuComponent_Template_a_click_3_listener() { return ctx.toggleQuickflowTab(); });
        i0.ɵɵtext(4, "Single");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "li", 2)(6, "a", 4);
        i0.ɵɵlistener("click", function QuickflowsMenuComponent_Template_a_click_6_listener() { return ctx.toggleQuickflowTab(); });
        i0.ɵɵtext(7, "Comparison");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(8, "ycn-single-select-quickflows", 5)(9, "ycn-multi-select-quickflows", 5);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0, ctx.showSingleSecurityQuickflowsTab));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c0, !ctx.showSingleSecurityQuickflowsTab));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", !ctx.showSingleSecurityQuickflowsTab)("displaySecurityId", ctx.displaySecurityId)("securityId", ctx.securityId)("securityName", ctx.securityName)("securityUrl", ctx.securityUrl);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.showSingleSecurityQuickflowsTab)("displaySecurityId", ctx.displaySecurityId)("securityId", ctx.securityId)("securityName", ctx.securityName)("securityUrl", ctx.securityUrl);
    } }, dependencies: [i3.NgClass, i4.MultiSelectQuickflowsComponent, i5.SingleSelectQuickflowsComponent], encapsulation: 2 });
